@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/size";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/typography/line-height";
@use "@inshared/ui-foundation/css/tokens/breakpoints";

web-select-funnel-entrance {
    --_bicycle-type-width: 120px;
    --_select-icon: url("/assets/icons/ui/chevron-down.svg");

    &.compact {
        --_bicycle-type-width: 90px;

        form {
            flex-direction: row;
        }
    }

    p {
        font-size: font-size.$xxs;
    }

    form {
        display: flex;
        gap: spacing.$md-lg;
        flex-direction: column;

        @media (min-width: breakpoints.$screen-sm-min) {
            flex-direction: row;
            align-items: center;
        }

        .fieldset {
            appearance: none;
            border: 0;
            padding: 0;
            margin: 0;
        }

        .select {
            position: relative;
            display: inline-block;

            select {
                width: 100%;
                font-size: font-size.$lg;
                margin: 0 auto;
                padding: size.$md;
                padding-right: size.$xl;
                border-color: color.$color-border;
                border-radius: border-radius.$md-lg;
                appearance: none;
                outline: none;

                &:active,
                &:focus {
                    border-color: color.$color-primary-darker;
                }

                &.no-value {
                    color: color.$color-placeholder;

                    option:not([disabled]) {
                        color: color.$color-text;
                    }
                }
            }

            &::after {
                content: "";
                mask-image: var(--_select-icon);
                background: color.$color-primary;
                width: 2rem;
                height: 2rem;
                position: absolute;
                right: spacing.$sm;
                top: 50%;
                transform: translateY(-50%);
                pointer-events: none;
            }
        }
    }

    .web-balloon {
        display: inline-block;
        margin-top: spacing.$lg;
    }
}
